








































import {Component, Vue} from 'vue-property-decorator';
import {resolveError} from '@/utils/notifications';
import IStockInternationalMovementFilters from '@/types/IStockInternationalMovementFilters';
import {IDataTablePagination} from '@/types/IPagination';
import IStockInternationalMovement from '@/types/IStockInternationalMovement';
import StockInternationalMovementService from '@/services/StockInternationalMovementService';
import Filters from '@/components/StockInternationalMovement/Filters.vue';
import StockInternationalMovementTable from '@/components/StockInternationalMovement/StockInternationalMovementTable.vue';
import {getSavedPageData, savePageData} from '@/utils/pageDataSaver';
import PageWrap from '@/components/PageWrap.vue';

@Component({
  name: 'StockInternationalMovements',
  components: {
    PageWrap,
    StockInternationalMovementTable,
    Filters
  },
})
export default class StockInternationalMovements extends Vue {
  stockInternationalMovements: IStockInternationalMovement[] = [];
  filters: IStockInternationalMovementFilters = {
    skuList: [],
    departureCountryList: [],
    arrivalCountryList: [],
    arrivalDateFrom: null,
    arrivalDateTo: null,
    departDateFrom: null,
    departDateTo: null,
    quantityFrom: null,
    quantityTo: null,
    page: 1,
    size: 10,
    totalElements: 0,
  };

  skuList: string[] = [];
  departureCountryList: string[] = [];
  arrivalCountryList: string[] = [];

  loading: boolean = false;

  onFiltersChanged(filters: IStockInternationalMovementFilters) {
    this.filters = {...this.filters, ...filters};
  }

  paginationChanged(pagination: IDataTablePagination) {
    this.filters.page = pagination.page;
    this.filters.size = pagination.itemsPerPage;

    this.fetchData();
  }

  sortChanged(sortable: IStockInternationalMovementFilters) {
    this.filters.sortBy = sortable.sortBy;
    this.filters.sortDirection = sortable.sortDirection;

    this.fetchData();
  }

  created() {
    this.getSavedFilters()
    this.fetchFiltersData();
  }

  getSavedFilters() {
    const { filters } = getSavedPageData()
    if (filters) {
      this.filters = filters
    }
  }

  async fetchFiltersData() {
    try {
      const {
        skuList,
        arrivalCountryList,
        departureCountryList
      } = await StockInternationalMovementService.getFilters();
      this.skuList = skuList;
      this.arrivalCountryList = arrivalCountryList;
      this.departureCountryList = departureCountryList;
    } catch (e) {
      resolveError(e, 'fetch_filters');
    }
  }

  async fetchData() {
    try {
      this.loading = true;
      const {
        stockInternationalMovements,
        totalElements,
      } = await StockInternationalMovementService.getAll(this.filters);
      savePageData({
        filters: this.filters
      })
      this.stockInternationalMovements = stockInternationalMovements;
      this.filters.totalElements = totalElements;
    } catch (e) {
      resolveError(e, 'fetch_data');
    } finally {
      this.loading = false;
    }
  }
}
